__webpack_require__.p = "/management/spa/vuejs/";